import { render } from "./PriceAndCost.vue?vue&type=template&id=284ffb8c&scoped=true&ts=true"
import script from "./PriceAndCost.ts?vue&type=script&lang=ts"
export * from "./PriceAndCost.ts?vue&type=script&lang=ts"

import "./PriceAndCost.vue?vue&type=style&index=0&id=284ffb8c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284ffb8c"]])

export default __exports__